<template>
  <div>
    <nav
      class="navbar navbar-expand-lg"
      style="border-bottom: 0;padding:0 !important;background:none;"
    >
      <div class="container-fluid" style="padding-left:0 !important;">
        <div class="navbar-minimize topNavbar">
          <button
            class="btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block topNav"
            style="border:none"
            @click="minimizeSidebar"
          >
            <i :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-navicon'"></i>
          </button>
        </div>
        <a class="navbar-brand">{{$route.name}}</a>
        <button
          type="button"
          class="navbar-toggler navbar-toggler-right"
          :class="{toggled: $sidebar.showSidebar}"
          aria-expanded="false"
          @click="toggleSidebar"
        >
          <span class="navbar-toggler-bar burger-lines"></span>
          <span class="navbar-toggler-bar burger-lines"></span>
          <span class="navbar-toggler-bar burger-lines"></span>
        </button>
        <div class="justify-content-end" style="position:absolute;right:0;padding-right:15px;">
          <ul class="navbar-nav" style="padding-right:1rem;">
            <!-- <i
              slot="title"
              class="fa fa-bell"
              style="margin-top: 1.95rem;font-size: larger;"
              @click="notiMenu"
            >-->
            <!-- <ii slot="title" class="fa fa-bell" style="font-size: larger;" @click="notiMenu"></i> -->

            <drop-down position="right" style="display:none;">
              <div slot="title">
                <img
                  v-bind:src="`${user.image ? user.image :'static/img/faces/face-0.jpg'}`"
                  alt
                  class="user-image mr-2"
                />
                <span>Hello {{user.firstName}}</span>
              </div>
              <div class="dialog-user mb-2">
                <div class="d-flex flex-wrap">
                  <div class="col-3">
                    <img
                      v-bind:src="`${user.image ? user.image :'static/img/faces/face-0.jpg'}`"
                      alt
                      class="dropdown-image mt-3"
                    />
                  </div>

                  <div class="col-9">
                    <div class="unameCls mt-4">{{user.firstName}} {{user.lastName}}</div>
                    <div class="emailCls mt-2">{{user.email}}</div>
                    <div class="divider"></div>
                    <div class="d-flex">
                      <button type="button" @click="editClick" class="editBtn">Edit Profile</button>
                      <button
                        type="button"
                        @click="logout"
                        class="editBtn ml-3"
                        style="color:#484848;"
                      >Logout</button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="fiifiUsers.length > 0">
                <div
                  class="switch-class"
                  v-for="item in fiifiUsers"
                  v-bind:key="item._id"
                  @click="switchAccount(item)"
                  style="border-bottom: inset;"
                >
                  <div class="d-flex flex-wrap">
                    <div class="col-3 pt-2" style="padding-left: 2rem !important;">
                      <img
                        v-bind:src="`${item.image ? item.image :'static/img/faces/face-0.jpg'}`"
                        alt
                        class="dropdown-image-2 mt-2"
                      />
                    </div>

                    <div class="col-9">
                      <div class="unameCls mt-4">{{item.firstName}} {{item.lastName}}</div>
                      <div class="emailCls mt-2 mb-2">{{item.email}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="divider" style="margin: 0px !important;"></div>
              <button type="button" @click="addAccount" class="editBtn m-2">Add Account</button>
            </drop-down>
          </ul>
        </div>
      </div>
    </nav>
    <ul
      class="dropdown-menu-noti bg-white"
      style="list-style:none"
      id="style-1"
      v-if="toggleNotiMenuCollapse"
    >
      <li class="noti-head">
        <div class="d-flex flex-wrap">
          <div class="col-lg-12 col-sm-12 col-12">
            <span
              class="text-dark"
              style="font-size: 18px;
                      line-height: 23px;
                      font-family: custom-helvetica-bold,roboto;"
            >Notification Center</span>
            <small class="float-right" style="padding-top:2px;">
              <i class="fa fa-plus" @click="handleCreateTodo"></i>
            </small>
          </div>
          <div class="col-lg-12 col-sm-12 col-12" style="display:none">
            <span
              class="text-dark"
              style="display: inline-block; font-size: 28px;font-weight: 300;"
            >All Notifications</span>
            <small class="float-right mt-3">Clear All</small>
          </div>
        </div>
      </li>
      <template v-for="(item,index) in tododata">
        <template v-if="item.priority == 'low'">
          <li
            class="notification-box alert-noti"
            style="background-color: rgba(193, 242, 178, 0.53);"
            :key="item._id"
          >
            <div class="d-flex flex-wrap">
              <div
                class="col-lg-3 col-sm-3 col-3 text-center"
                style="padding-top:0.4rem"
                @click="handleEditTodo(item,index)"
              >
                <i class="fa fa-exclamation noti-low-exclamation-icon"></i>
              </div>
              <div class="col-lg-9 col-sm-9 col-9" style="padding: 0px 0px !important;">
                <span>
                  <div class="d-flex">
                    <div
                      class="noti-low-title flex-grow-1 pt-2"
                      @click="handleEditTodo(item,index)"
                    >{{item.title}}</div>
                    <a
                      class="ml-3 pt-1 mr-1"
                      style="font-size: 10px;line-height: 12px;"
                      @click="handleStatusEditTodo(item,index)"
                    >
                      <i class="fa fa-close"></i>
                    </a>
                  </div>
                </span>
                <div
                  @click="handleEditTodo(item,index)"
                  class="noti-low-description"
                >{{item.description}}</div>
                <div class="noti-low-date" @click="handleEditTodo(item,index)">
                  <!-- <i class="fa fa-clock-o mr-1"></i> -->
                  {{ moment(item.due_date).format('YYYY-MM-DD')}}
                </div>
              </div>
            </div>
          </li>
        </template>
        <template v-if="item.priority == 'urgent'">
          <li
            class="notification-box alert-noti"
            style="background-color:rgba(237, 202, 202, 0.53)"
            :key="item._id"
          >
            <div class="d-flex flex-wrap">
              <div
                class="col-lg-3 col-sm-3 col-3 text-center"
                style="padding-top:0.4rem"
                @click="handleEditTodo(item,index)"
              >
                <i class="fa fa-exclamation noti-urgent-exclamation-icon"></i>
              </div>
              <div class="col-lg-9 col-sm-9 col-9" style=" padding: 0px 0px !important;">
                <div class="d-flex">
                  <div
                    class="noti-urgent-title flex-grow-1 pt-2"
                    @click="handleEditTodo(item,index)"
                  >{{item.title}}</div>
                  <a
                    class="ml-3 pt-1 mr-1"
                    style="font-size: 10px;line-height: 12px;"
                    @click="handleStatusEditTodo(item,index)"
                  >
                    <i class="fa fa-close"></i>
                  </a>
                </div>
                <div
                  @click="handleEditTodo(item,index)"
                  class="noti-urgent-description"
                >{{item.description}}</div>
                <div class="noti-urgent-date" @click="handleEditTodo(item,index)">
                  <!-- <i class="fa fa-clock-o mr-1"></i> -->
                  {{ moment(item.due_date).format('YYYY-MM-DD')}}
                </div>
              </div>
            </div>
          </li>
        </template>
        <template v-if="item.priority == 'medium'">
          <li
            class="notification-box alert-noti"
            style="background-color:rgba(240, 238, 255, 0.53)"
            :key="item._id"
          >
            <div class="d-flex flex-wrap">
              <div
                class="col-lg-3 col-sm-3 col-3 text-center"
                style="padding-top:0.4rem"
                @click="handleEditTodo(item,index)"
              >
                <i class="fa fa-exclamation noti-medium-exclamation-icon"></i>
              </div>
              <div class="col-lg-9 col-sm-9 col-9" style="padding: 0px 0px !important;">
                <div class="d-flex">
                  <div
                    class="noti-urgent-title flex-grow-1 pt-2"
                    @click="handleEditTodo(item,index)"
                  >{{item.title}}</div>
                  <a
                    class="ml-3 pt-1 mr-1"
                    style="font-size: 10px;line-height: 12px;"
                    @click="handleStatusEditTodo(item,index)"
                  >
                    <i class="fa fa-close"></i>
                  </a>
                </div>
                <div
                  @click="handleEditTodo(item,index)"
                  class="noti-urgent-description"
                >{{item.description}}</div>
                <div class="noti-urgent-date" @click="handleEditTodo(item,index)">
                  <!-- <i class="fa fa-clock-o mr-1"></i> -->
                  {{ moment(item.due_date).format('YYYY-MM-DD')}}
                </div>
              </div>
            </div>
          </li>
        </template>
      </template>
    </ul>
    <dialogtodo v-model="dialogTodoData" v-if="showDialogModal"></dialogtodo>
  </div>
</template>
<script>
import DialogAddTodo from "../Dialogs/DialogAddTodo";
import moment from "moment";
import { mapGetters } from "vuex";
import NotificationSample from "../Components/NotificationSample";
import api from "../../../axios_api";
export default {
  components: {
    [DialogAddTodo.name]: DialogAddTodo
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("todo", ["current_component"]),
    moment() {
      return moment;
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    tododata() {
      return this.$store.getters["todo/todos"];
    }
  },
  mounted() {
    this.displayUser(this.$route.params.account_id);
    this.email = localStorage.getItem("email")
      ? localStorage.getItem("email")
      : "";
    this.$watch(
      () => {
        return this.$route.params.account_id;
      },
      account_id => {
        if (account_id) {
          this.displayUser(account_id);
        }
      }
    );
  },
  data() {
    return {
      showDialogModal: false,
      dialogTodoData: {},
      toggleNotiMenuCollapse: 0,
      activeNotifications: false,
      email: "",
      fiifiUsers: []
    };
  },
  methods: {
    addAccount() {
      let user = JSON.parse(window.localStorage.getItem("fiifi")).user;
      let userObj = {
        _id: user._id || user.id,
        workspace_id: user.workspace_id,
        image: user.image,
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email
      };
      if (window.localStorage.getItem("fiifiUsers")) {
        let users = JSON.parse(window.localStorage.getItem("fiifiUsers"));
        if (users.findIndex(item => item._id == userObj._id) == -1) {
          window.localStorage.removeItem("fiifiUsers");
          users.push(userObj);
          window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
        }
      } else {
        let users = [];
        users.push(userObj);
        window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
      }
      this.$router.push("/login?redirect=account");
    },
    switchAccount(item) {
      item.id = item._id;
      api
        .post("/switch/user", { encrypt: { data: item } })
        .then(data => {
          this.$store.dispatch("arbiter/shutdown");
          let user = data.data.encrypt.success.user;
          user.token = data.data.encrypt.success.token;
          user.isNew = data.data.encrypt.success.isNew;
          this.$store.commit("user/token", {
            token: data.data.encrypt.success.token
          });
          this.$store.commit("portfolio/markData", {
            hasData: data.data.encrypt.success.hasData
          });
          user.workspace_id =
            data.data.encrypt.success.workspaceDetails.workspace;
          user.email = item.email;
          if (item.image) user.image = item.image;
          this.$store.commit("user/user", {
            user
          });
          this.$store.dispatch("arbiter/start");
          this.$notify({ component: NotificationSample, timeout: 8000 });
          window.localStorage.setItem("email", item.email);
          this.displayUser(user._id);
          this.$router.push(`/${user._id}/${user.workspace_id}/`);
        })
        .catch(err => console.log(err));
    },
    editClick() {
      this.$router.push(
        `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/profile`
      );
    },
    logout() {
      window.sessionStorage.clear();
      if (localStorage.getItem("fiifiUsers") && this.$route.params.account_id) {
        let fiifiUsers = JSON.parse(localStorage.getItem("fiifiUsers"));
        let index = fiifiUsers.findIndex(
          item => item._id == this.$route.params.account_id
        );
        fiifiUsers.splice(index, 1);
        window.localStorage.setItem("fiifiUsers", JSON.stringify(fiifiUsers));
      }
      this.$router.push("/login");
    },
    displayUser(account_id) {
      if (localStorage.getItem("fiifiUsers") && this.$route.params.account_id) {
        this.fiifiUsers = JSON.parse(localStorage.getItem("fiifiUsers"));
        let index = this.fiifiUsers.findIndex(item => item._id == account_id);
        this.fiifiUsers.splice(index, 1);
      }
    },
    notiMenu() {
      this.toggleNotiMenuCollapse = !this.toggleNotiMenuCollapse;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    handleCreateTodo() {
      this.showDialogModal = true;
      this.dialogTodoData = {
        isShow: true,
        isCreate: true,
        data: {
          priority: "medium",
          due_date: new Date().setDate(new Date().getDate() + 3),
          status: "New",
          is_quick_task: false
        },
        assigned_to: [this.$route.params.account_id]
      };
    },
    handleEditTodo(item, index) {
      let todoData = JSON.parse(JSON.stringify(item));
      this.$store.commit("todo/setTodoIndex", {
        _id: todoData._id,
        index: index
      });
      this.showDialogModal = true;
      this.dialogTodoData = {
        isShow: true,
        isCreate: false,
        data: todoData,
        assigned_to: todoData.assigned_to
      };
    },
    handleStatusEditTodo(item, index) {
      // this.$store.commit("todo/setTodoIndex", {
      //   _id: item._id,
      //   index: index
      // });
      item.status = "Done";
      api
        .patch("/todo", {
          encrypt: {
            data: {
              todo: item
            }
          }
        })
        .then(data => {
          //this.$store.commit("todo/EditTodoData", data.data.encrypt.data);
          this.$store.dispatch(
            "todo/getAllTodos",
            this.$route.params.workspace_id
          );
          this.$store.getters["todo/componentTodos"](
            this.current_component,
            this.$route.params.workspace_id
          );
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #17a2b8;
}

.dropdown-menu-noti {
  position: absolute;
  right: 0px;
  left: unset;
  width: 334px;
  box-shadow: 0px 5px 7px -1px #c1c1c1;
  padding-bottom: 10px !important;
  padding: 0px;
  z-index: 1;
  max-height: 500px;
  overflow: auto;
}

.noti-head {
  padding: 15px 15px;
  border-radius: 3px 3px 0px 0px;
  height: 50px;
}

.notification-box {
  padding: 3px 0px;
  margin: 5px 10px;
}

.alert-noti {
  position: relative;
  /* margin-bottom: 0rem;
  border: 1px solid antiquewhite; */
}

@media (max-width: 640px) {
  .dropdown-menu-noti {
    top: 50px;
    left: -16px;
    width: 290px;
  }

  .nav {
    display: block;
  }

  .nav .nav-item,
  .nav .nav-item a {
    padding-left: 0px;
  }
}
#style-1::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#style-1::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

#style-1::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}
.user-image {
  border-radius: 50%;
  height: 30px;
}
.switch-class {
  background-color: #f9f9f9;
}
.dropdown-image {
  border-radius: 50%;
  height: 85px;
  width: 85px;
}
.dropdown-image-2 {
  border-radius: 50%;
  height: 55px;
  width: 55px;
}
.dialog-user {
  padding-right: 0px;
  width: 481px;
}
.unameCls {
  text-align: left !important;
  font: Bold 18px/23px Helvetica Neue;
  letter-spacing: 0;
  color: #484848;
  opacity: 1;
}
.emailCls {
  font: Bold 14px/17px Helvetica Neue;
  letter-spacing: 0;
  color: #484848;
  opacity: 1;
}

.editBtn {
  text-align: left;
  font: Bold 12px/15px Helvetica Neue;
  letter-spacing: 0;
  color: #989898;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #d5d5d5;
  opacity: 1;
  top: 174px;
  left: 1119px;
  width: 92px;
  height: 27px;
}

.navbar .topNav .btn-round.btn-icon {
  padding: 0 !important;
}

.btn.btn-outline:hover {
  background-color: #f1f1f2 !important;
  color: #89888b;
}

.navbar .topNav .btn {
  margin: 0 !important;
}

/* .topNav .btn.btn-outline {
  background: none !important;
  border: none !important;
} */

/* .topNav .btn:hover,
.btn:focus {
  background: none !important;
  border: none !important;
}

.topNav .btn {
  border: none !important;
}

.topNav .btn-round {
  border: none !important;
} */
</style>

